import {
  Dimensions,
  ImageSourcePropType,
  Modal,
  StyleSheet,
  TouchableOpacity,
} from 'react-native';

import {Box} from '@buncha/components/core/view';
import CrossRoundedIcon from '@buncha/components/core/icon/CrossRoundedIcon';
import CustomZoomImage from '@buncha/components/core/Image/CustomZoomImage.web';
import React from 'react';
import {scaleFonts} from '@buncha/appStyles/style/font';
import {useColorThemeType} from '@buncha/appStyles/hooks/theme';

interface Props {
  open: boolean;
  onClose: () => void;
  image: ImageSourcePropType;
}

const ImageModal = (props: Props) => {
  const {image, onClose, open} = props;
  const theme = useColorThemeType();
  return (
    <Modal visible={open} transparent onRequestClose={onClose}>
      <Box style={styles.mainContainer}>
        <Box style={styles.conatiner}>
          <TouchableOpacity onPress={onClose} style={[styles.cross]}>
            <Box
              style={[
                styles.crossContainer,
                {
                  backgroundColor: theme?.background.white[100],
                },
              ]}>
              <CrossRoundedIcon
                width={scaleFonts(36)}
                height={scaleFonts(36)}
                fill={theme?.icon.blue[300]}
                viewBox="-2 -2 19 20"
              />
            </Box>
          </TouchableOpacity>
          <CustomZoomImage source={image} imageStyle={styles.image} />
        </Box>
      </Box>
    </Modal>
  );
};

export default React.memo(ImageModal);

export const styles = StyleSheet.create({
  mainContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)', // backdrop color
  },
  conatiner: {
    borderRadius: 10,
    marginVertical: Dimensions.get('window').height / 4,
    marginHorizontal: 40,
    position: 'relative',
  },
  cross: {
    position: 'absolute',
    top: -60,
    left: Dimensions.get('window').width / 2 - 60,
    zIndex: 10,
  },
  image: {
    borderRadius: 10,
    height: Dimensions.get('window').height / 2,
    width: Dimensions.get('window').width - 80,
  },
  crossContainer: {borderRadius: 50, padding: 5},
});
